import { ButtonGroup } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { TextareaAutosize } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { FhirClientContext } from '../../FhirClientContext';
import {
  getExternalServerUrl,
  getExternalServiceRequestId,
  isExternalReference,
} from '../utils/checkExternalReference';
import { getVectorConfig } from '../utils/getConfig';
import { getOwnDisplayname, getOwnOrganization, getOwnPractitionerRole } from '../utils/getOwn';
import DicomUploadDialog from './DicomUploadDialog';
import PdfExport from './pdfexport/PdfExport';

class CaseFooter extends React.Component {
  static contextType = FhirClientContext;

  constructor(props) {
    super(props);

    this.fileType = [
      'Anamnesis',
      'MedicalLetter',
      'Haemodynamics',
      'Respiration',
      'BloodGasAnalysis',
      'Perfusors',
      'InfectiousDisease',
      'Radiology',
      'Lab',
      'Others',
    ];

    this.state = {
      dialogRequestOpen: false,
      dialogAttachmentOpen: false,
      message: '',
      selectedFiles: [],
      fileCategory: this.fileType[9],
      fileError: '',
      fileUploadAllowed: false,
      ownOrganization: '',
      ownPractitionerRole: '',
      confirmationTitle: '',
      confirmationText: '',
      confirmationOpen: false,
      currentDraft: '',
      videoconferencesEnabled: false,
      dicomEnabled: false,
      dialogDicomOpen: false,
      dicomError: '',
      dicomUploadAllowed: false,
      selectedDicomFile: null,
    };

    this.saveDicom = this.saveDicom.bind(this);
  }

  componentWillUnmount() {}

  async componentDidMount() {
    const config = await getVectorConfig('/config');
    this.setState({ videoconferencesEnabled: config.enable_videoconferences });
    this.setState({ dicomEnabled: config.enable_dicom });

    // check for own organization
    const client = this.context.client;
    this.props.setOwnDisplayname(await getOwnDisplayname(client));
    this.setState({
      ownOrganization: await getOwnOrganization(client),
      ownPractitionerRole: await getOwnPractitionerRole(client),
    });
  }

  // TODO warum muss ich das hier binden und in anderen Klassen nicht??
  onRequestButtonClick = () => {
    const client = this.context.client;
    client.request(`ServiceRequest/${this.props.sr_id}`, { pageLimit: 0, flat: true }).then(srData => {
      client
        .request(
          {
            url: `Communication?based-on=ServiceRequest/${this.props.sr_id}&_sort=-sent`,
            federatedServerUrl: getExternalServerUrl(srData, client),
          },
          {
            pageLimit: 0,
            flat: true,
          }
        )
        .then(communicationData => {
          if (communicationData[0] && communicationData[0].status == 'preparation') {
            this.setState({
              currentDraft: communicationData[0].id,
              message: communicationData[0].note ? communicationData[0].note[0].text : '',
            });
          }
          this.setState({ dialogRequestOpen: true });
        });
    });
  };

  onRequestDialogClose = () => {
    this.setState({ dialogRequestOpen: false, message: '' });
  };

  onTextfieldChange = event => {
    this.setState({ message: event.target.value });
  };

  onSaveRequestAsDraft = () => {
    const client = this.context.client;
    // we already have a draft
    if (this.state.currentDraft) {
      client.request(`ServiceRequest/${this.props.sr_id}`, { pageLimit: 0, flat: true }).then(srData => {
        client
          .patch(
            `Communication/${this.state.currentDraft}`,
            [
              {
                op: 'add',
                path: '/note',
                value: [
                  {
                    text: `${this.state.message}`,
                  },
                ],
              },
              {
                op: 'replace',
                path: '/sent',
                value: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSSXXX"),
              },
            ],
            {
              url: `Communication/${this.state.currentDraft}`,
              federatedServerUrl: getExternalServerUrl(srData, client),
            }
          )
          .then(patchedData => {
            this.props.updateCommunications(patchedData);
          });
      });
    } else {
      this.createCommunication(true, '', '');
    }
    this.setState({ dialogRequestOpen: false });
  };

  onSendRequest = () => {
    const client = this.context.client;
    if (this.state.currentDraft) {
      const currentDraft = this.state.currentDraft;
      const message = this.state.message;

      client.request(`ServiceRequest/${this.props.sr_id}`, { pageLimit: 0, flat: true }).then(srData => {
        const externalServerUrl = getExternalServerUrl(srData, client);
        const senderRecipientData = this.getSenderRecipient(srData, externalServerUrl);

        const patchOperations = [
          {
            op: 'add',
            path: '/recipient',
            value: [
              {
                reference: `${senderRecipientData.recipient}`,
              },
            ],
          },
          {
            op: 'replace',
            path: '/sent',
            value: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSSXXX"),
          },
          {
            op: 'replace',
            path: '/status',
            value: 'in-progress',
          },
        ];

        // add message if it is set
        if (message && message.trim() !== '') {
          patchOperations.unshift({
            op: 'add',
            path: '/note',
            value: [
              {
                text: message,
              },
            ],
          });
        }

        client.patch(
          `Communication/${currentDraft}`,
          patchOperations,
          {
            url: `Communication/${currentDraft}`,
            federatedServerUrl: getExternalServerUrl(srData, client),
          }
        )
        .then(patchedData => {
            this.props.updateCommunications(patchedData);
        });
      });
    } else {
      this.createCommunication(false, '', '');
    }
    this.setState({ dialogRequestOpen: false, currentDraft: '', message: '' });
  };

  onAttachmentButtonClick = () => {
    this.setState({ dialogAttachmentOpen: true });
  };

  onAttachPDFButtonClick = () => {
    this.setState({ dialogAttachmentOpen: true, fileCategory: this.fileType[1] });
  };

  onAttachmentDialogClose = () => {
    this.setState({ fileError: '', dialogAttachmentOpen: false });
  };

  onDicomButtonClick = () => {
    this.setState({ dialogDicomOpen: true });
  };

  onDicomDialogClose = () => {
    this.setState({ dicomError: '', dialogDicomOpen: false });
  };

  onSaveAttachment = () => {
    this.saveAttachment();
    this.setState({ dialogAttachmentOpen: false });
  };

  onFileCategoryChange = event => {
    this.setState({ fileCategory: event.target.value });
  };

  onFileChangeHandler = event => {
    const { t, i18n } = this.props;
    const files = Array.from(event.target.files); // convert to array
    if (files.length === 0) return;
    //only allow a max of 20 for upload
    const maxFiles = 20;
    if (files.length > maxFiles) {
      this.setState({ fileError: t('A maximum of 20 files can be selected.'), fileUploadAllowed: false });
      return;
    }
    const validFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSize = 10 * 1024 * 1024; //max. 10MB

    let validFiles = [];
    let fileError = '';

    for (const file of files) {
      if (!validFileTypes.includes(file.type)) {
        fileError = t('Invalid file type');
        break;
      } else if (file.size > maxFileSize) {
        fileError = t('File is too large');
        break;
      } else if (!file?.name || file.name.trim() === '') {
        fileError = t('File has no name');
        break;
      } else {
        validFiles.push(file);
      }
    }

    this.setState({
      selectedFiles: validFiles,
      fileError: fileError,
      fileUploadAllowed: fileError === '', // only allow upload if no error exists
    });
  };

  onCloseConsultationButtonClick = () => {
    const { t } = this.props;
    if (!this.props.srIsOnHoldBy) {
      // send request to close the case
      this.setState({
        confirmationTitle: t('Send request for closing the consultation?'),
        confirmationText: t('The consultation partner has to confirm the request to close the consultation.'),
        confirmationAgree: t('Send'),
        confirmationDisagree: t('Cancel'),
        confirmationOpen: true,
      });
    } else {
      // close the case
      this.setState({
        confirmationTitle: t('Request for closing the consultation'),
        confirmationText: t('The consultation partner wants to close the consultation.'),
        confirmationAgree: t('Confirm'),
        confirmationDisagree: t('Decline'),
        confirmationOpen: true,
      });
    }
  };

  onStartVideoconferenceButtonClick = async () => {
    const client = this.context.client;
    let roomName = uuidv4(); // ⇨ '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'
    this.createCommunication(false, roomName, '');
    await client.refreshIfNeeded();
    this.props.setVideoconferenceLink(roomName);
  };

  onConfirmationAgree = () => {
    if (!this.props.srIsOnHoldBy) {
      // send request to close the case
      // read sr
      const client = this.context.client;
      client
        .request('ServiceRequest/' + this.props.sr_id, {
          pageLimit: 0,
          flat: true,
        })
        .then(sr => {
          // set new status for ServiceRequest
          if (getExternalServiceRequestId(sr, client)) {
            client
              .request({
                url: 'ServiceRequest/' + getExternalServiceRequestId(sr, client),
                federatedServerUrl: getExternalServerUrl(sr, client),
              })
              .then(srData => {
                srData.status = 'on-hold';
                if (this.state.ownPractitionerRole) {
                  srData.supportingInfo = [{ reference: this.state.ownPractitionerRole }];
                } else {
                  srData.supportingInfo = [{ reference: this.state.ownOrganization }];
                }
                this.props.setSrIsOnHoldBy(this.state.ownOrganization);
                client.update(srData, {
                  url: getExternalServerUrl(sr, client),
                  federatedServerUrl: getExternalServerUrl(sr, client),
                });
              });
          }
          sr.status = 'on-hold';
          if (this.state.ownPractitionerRole) {
            sr.supportingInfo = [{ reference: this.state.ownPractitionerRole }];
          } else {
            sr.supportingInfo = [{ reference: this.state.ownOrganization }];
          }
          this.props.setSrIsOnHoldBy(this.state.ownOrganization);
          client.update(sr);
        });
    } else {
      // close the case
      const client = this.context.client;
      client
        .request('ServiceRequest/' + this.props.sr_id, {
          pageLimit: 0,
          flat: true,
        })
        .then(sr => {
          // set new status for ServiceRequest
          if (getExternalServiceRequestId(sr, client)) {
            client
              .request({
                url: 'ServiceRequest/' + getExternalServiceRequestId(sr, client),
                federatedServerUrl: getExternalServerUrl(sr, client),
              })
              .then(srData => {
                srData.status = 'completed';
                this.props.setSrIsArchived(true);
                client.update(srData, {
                  url: getExternalServerUrl(sr, client),
                  federatedServerUrl: getExternalServerUrl(sr, client),
                });
              });
          }
          sr.status = 'completed';
          this.props.setSrIsArchived(true);
          client.update(sr);
        });
    }
    this.setState({ confirmationOpen: false });
  };

  onConfirmationDisagree = () => {
    if (this.props.srIsOnHoldBy) {
      // decline request to close the case
      // read sr
      const client = this.context.client;
      client
        .request('ServiceRequest/' + this.props.sr_id, {
          pageLimit: 0,
          flat: true,
        })
        .then(sr => {
          // set new status for ServiceRequest
          if (getExternalServiceRequestId(sr, client)) {
            client
              .request({
                url: 'ServiceRequest/' + getExternalServiceRequestId(sr, client),
                federatedServerUrl: getExternalServerUrl(sr, client),
              })
              .then(srData => {
                srData.status = 'active';
                client.update(srData, {
                  url: getExternalServerUrl(sr, client),
                  federatedServerUrl: getExternalServerUrl(sr, client),
                });
              });
          }

          sr.status = 'active';
          client.update(sr);
          this.props.setSrIsOnHoldBy('');
        });
    }
    this.setState({ confirmationOpen: false });
  };

  onConfirmationDialogClose = () => {
    this.setState({ confirmationOpen: false });
  };

  getSenderRecipient = (srData, externalServerUrl) => {
    const client = this.context.client;
    const senderRole = this.state.ownPractitionerRole ? this.state.ownPractitionerRole : this.state.ownOrganization;
    let isExternalPerformer = isExternalReference(srData.performer[0].reference, client);

    let sender = null;
    let recipient = null;
    let extension = null;

    if (externalServerUrl == null && isExternalPerformer) {
      // federated consultation but i am the base server
      const externalBaseUrl = new URL(srData.performer[0].reference).origin + '/hapi-fhir-jpaserver/fhir/';
      sender = senderRole;
      recipient = externalBaseUrl + 'Organization/' + this.props.srRecipient;
    } else if (externalServerUrl) {
      // federated consultation but i am the federated server
      const clientServerUrl = client.state.serverUrl.endsWith('/')
        ? client.state.serverUrl
        : client.state.serverUrl + '/';
      sender = clientServerUrl + this.state.ownOrganization;
      recipient = 'Organization/' + this.props.srRecipient;
      extension = [
        {
          url: 'clinic.amp.app.sender.person',
          valueReference: clientServerUrl + senderRole,
        },
      ];
    } else {
      // internal consultation
      sender = senderRole;
      recipient = 'Organization/' + this.props.srRecipient;
    }

    return { sender: sender, recipient: recipient, extension: extension };
  };

  createCommunication(draft, videoconfName, attachments) {
    const client = this.context.client;
    const message = this.state.message;

    client.request(`ServiceRequest/${this.props.sr_id}`, { pageLimit: 0, flat: true }).then(srData => {
      const status = draft ? 'preparation' : 'in-progress';
      const srId = getExternalServiceRequestId(srData, client) ?? this.props.sr_id;

      const externalServerUrl = getExternalServerUrl(srData, client);
      const senderRecipientData = this.getSenderRecipient(srData, externalServerUrl);

      let resource = {
        resourceType: 'Communication',
        basedOn: [
          {
            reference: 'ServiceRequest/' + srId,
          },
        ],
        status: status,
        category: [
          {
            text: this.props.srCategory,
          },
        ],
        priority: 'asap',
        subject: {
          reference: 'Patient/' + this.props.srSubject,
        },
        sent: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSSXXX"),
        recipient: [
          {
            reference: draft ? '' : senderRecipientData.recipient,
          },
        ],
        sender: {
          reference: senderRecipientData.sender,
        },
      };

      if (senderRecipientData.extension !== null) {
        resource.extension = senderRecipientData.extension;
      }

      // communication represents a message
      if (message != '') {
        resource = {
          ...resource,
          note: [
            {
              text: message,
            },
          ],
        };
      }
      // communication represents a videoconference
      if (videoconfName) {
        resource = {
          ...resource,
          medium: [
            {
              coding: [
                {
                  code: 'VIDEOCONF',
                  userSelected: true,
                },
              ],
            },
          ],
          topic: {
            coding: [
              {
                code: 'VIDEOCONFERENCE',
              },
            ],
          },
          payload: [
            {
              contentString: videoconfName,
            },
            {
              contentString: JSON.stringify({ start_time: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSSXXX") }),
            },
          ],
        };
      }

      if (attachments) {
        resource = {
          ...resource,
          payload: attachments.map(attachment => ({
            contentReference: {
              reference: attachment,
            },
          })),
        };
      }

      client
        .create(resource, {
          url: externalServerUrl,
          federatedServerUrl: externalServerUrl,
          headers: { Authorization: 'Bearer ' + client.state.tokenResponse.access_token },
        })
        .then(data => {
          if (attachments && attachments.length > 0) {
            const event = new CustomEvent('newAttachmentAdded');
            document.dispatchEvent(event);
          }
          if(draft) {
            this.setState({ currentDraft: data.id });
          }
          this.props.addCommunication(data, true);
        });
    });
  }

  blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  async saveAttachment() {
    // check if array is empty
    if (!this.state.selectedFiles || this.state.selectedFiles.length === 0) return;

    const client = this.context.client;
    const serviceRequestId = this.props.sr_id;
    const srData = await client.request('ServiceRequest/' + serviceRequestId);

    // create DocumentReference for each selected file
    const uploadPromises = this.state.selectedFiles.map(async selectedFile => {
      let fileData = await this.blobToBase64(selectedFile);
      fileData = fileData.split(',')[1];

      const contentType = selectedFile.type;
      const author = this.state.ownPractitionerRole;
      const custodian = this.state.ownOrganization;

      const resource = {
        resourceType: 'DocumentReference',
        status: 'current',
        docStatus: 'preliminary',
        category: [
          {
            // the category Radiology is misspelled in the app, so for compatibility reasons it is translated here
            text: this.state.fileCategory === 'Radiology' ? 'Radeology' : this.state.fileCategory,
          },
        ],
        subject: {
          reference: 'Patient/' + this.props.srSubject,
        },
        date: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSSXXX"),
        author: [
          {
            reference: author,
          },
        ],
        custodian: {
          reference: custodian,
        },
        content: [
          {
            attachment: {
              contentType: contentType,
              data: fileData,
              title: selectedFile.name,
            },
            format: {
              system: 'https://www.hl7.org/fhir/valueset-formatcodes.html',
              code: 'urn:ihe:iti:xds:2017:mimeTypeSufficient',
              display: 'mimeType Sufficient',
            },
          },
        ],
        context: {
          related: [
            {
              reference: 'ServiceRequest/' + serviceRequestId,
            },
          ],
        },
      };

      const data = await client.create(resource);
      return `DocumentReference/${data.id}`;
    });

    try {
      const uploadedReferences = await Promise.all(uploadPromises);
      if (uploadedReferences) {
        console.log('All files have been successfully uploaded.');

        client
          .request(
            {
              url: `Communication?based-on=ServiceRequest/${serviceRequestId}&_sort=-sent`,
              federatedServerUrl: getExternalServerUrl(srData, client),
            },
            {
              pageLimit: 0,
              flat: true,
            }
          )
          .then(async communicationData => {
            //check if there is an active draft -> add the DocumentReference to this Communication
            let isActiveDraft = communicationData[0] && communicationData[0].status == 'preparation' ? true : false;
            if (isActiveDraft) {
              const patchPromises = uploadedReferences.map(reference => {
                let path = '/payload';
                let value = [
                  {
                    contentReference: {
                      reference: reference,
                    },
                  }
                ];

                // there is already a payload
                if (communicationData[0].payload) {
                  path = '/payload/-';
                  value = {
                    contentReference: {
                      reference: reference,
                    },
                  };
                }

                return client.patch(
                  `Communication/${communicationData[0].id}`,
                  [
                    {
                      op: 'add',
                      path: path,
                      value: value,
                    },
                  ],
                  {
                    url: getExternalServerUrl(srData, client),
                    federatedServerUrl: getExternalServerUrl(srData, client),
                  }
                );
              });

              await Promise.all(patchPromises)
                .then(() => {
                  this.props.updateCommunications(communicationData[0]);
                  const event = new CustomEvent('newAttachmentAdded');
                  document.dispatchEvent(event);
                })
                .catch(error => {
                  console.error('Error while patching: ', error);
                });
            } else {
              this.createCommunication(true, null, uploadedReferences);
            }
          });
      }
      this.props.reRender(); // Update UI after upload
    } catch (error) {
      console.error('Error while uploading: ', error);
    }
  }

  async saveDicom(study_id) {
    if (!study_id) {
      return;
    }

    let author = this.state.ownPractitionerRole;
    const client = this.context.client;

    // get current ServiceRequest
    client.request('ServiceRequest/' + this.props.sr_id).then(srData => {
      const serviceRequestId = getExternalServiceRequestId(srData, client) ?? this.props.sr_id;

      // create new ImagingStudy ressource
      const resource = {
        resourceType: 'ImagingStudy',
        status: 'available',
        identifier: {
          use: 'official',
          system: 'urn:dicom:uid',
          value: 'urn:oid:' + study_id,
        },
        subject: {
          reference: 'Patient/' + this.props.srSubject,
        },
        started: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSSXXX"),
        referrer: [
          {
            reference: author,
          },
        ],
        basedOn: {
          reference: 'ServiceRequest/' + serviceRequestId,
        },
      };

      // get Communications linked to this ServiceRequest
      client
        .request(
          {
            url: `Communication?based-on=ServiceRequest/${serviceRequestId}&_sort=-sent`,
            federatedServerUrl: getExternalServerUrl(srData, client),
          },
          {
            pageLimit: 0,
            flat: true,
          }
        )
        .then(async communicationData => {
          // check if there is an active draft -> add the DocumentReference to this Communication
          let isActiveDraft = communicationData[0] && communicationData[0].status == 'preparation' ? true : false;
          if (isActiveDraft) {
            let dicomStudyIds = [];
            if (communicationData[0]?.payload !== undefined) {
              let imagingStudies = [];
              communicationData[0].payload.forEach(ref => {
                // com contains an ImagingStudy
                if (ref.contentReference !== undefined && ref.contentReference.reference.startsWith('ImagingStudy')) {
                  imagingStudies.push(ref.contentReference.reference);
                }
              });

              await Promise.all(
                imagingStudies.map(async id => {
                  await client
                    .request(
                      {
                        url: `${id}`,
                        federatedServerUrl: this.props.externalServerUrl,
                      },
                      {
                        pageLimit: 0,
                        flat: true,
                      }
                    )
                    .then(data => {
                      let studyId = data.identifier[0].value.split(':').slice(-1)[0];
                      dicomStudyIds = [...dicomStudyIds, studyId];
                      return dicomStudyIds;
                    });
                })
              );
            }

            // if there are studies with the same id already present in the draft, do not create a new resource
            if (dicomStudyIds.filter(o => o == study_id).length === 0) {
              // create Communication
              client.create(resource).then(data => {
                // is there an active draft Communication?, then add the ImagingStudy to this Communication
                client
                  .patch(
                    `Communication/${communicationData[0].id}`,
                    [
                      {
                        op: 'add',
                        path: communicationData[0].payload ? '/payload/-' : '/payload',
                        value: communicationData[0].payload
                          ? {
                              contentReference: {
                                reference: `ImagingStudy/${data.id}`,
                              },
                            }
                          : [
                              {
                                contentReference: {
                                  reference: `ImagingStudy/${data.id}`,
                                },
                              },
                            ],
                      },
                    ],
                    {
                      url: getExternalServerUrl(srData, client),
                      federatedServerUrl: getExternalServerUrl(srData, client),
                    }
                  )
                  .then(patchedData => {
                    this.props.updateCommunications(patchedData);
                    const event = new CustomEvent('newAttachmentAdded');
                    document.dispatchEvent(event);
                    this.onDicomDialogClose();
                  });
              });
            }
          } else {
            await client.create(resource).then(data => {
              this.createCommunication(true, null, [`ImagingStudy/${data.id}`]);
              this.onDicomDialogClose();
            });
          }
        });
    });

    // trigger reload of communications
    this.props.reRender();
  }

  render() {
    const { t } = this.props;

    const canCloseCase = this.props.srIsOnHoldBy != this.state.ownOrganization ? true : false;
    const disableCloseCase = !canCloseCase || this.props.srIsArchived;
    const readonly = this.props.srIsOnHoldBy ? true : false || this.props.srIsArchived;
    const videoconf = readonly || this.props.videoconfActive;

    const videoconferenceButton = !this.state.videoconferencesEnabled ? null : (
      <Button variant="contained" color="primary" onClick={this.onStartVideoconferenceButtonClick} disabled={videoconf}>
        {t('Start Videoconference')}
      </Button>
    );

    const dicomUploadButton = !this.state.dicomEnabled ? null : (
      <Button variant="contained" color="primary" onClick={this.onDicomButtonClick} disabled={readonly}>
        {t('Upload Dicom Image')}
      </Button>
    );

    return (
      <div className="caseFooter">
        <ButtonGroup>
          <Button variant="contained" color="primary" onClick={this.onRequestButtonClick} disabled={readonly}>
            {t('New message')}
          </Button>
          <Button variant="contained" color="primary" onClick={this.onAttachmentButtonClick} disabled={readonly}>
            {t('Add attachment')}
          </Button>
          {dicomUploadButton}
          {videoconferenceButton}
          <Button
            variant="contained"
            color="primary"
            onClick={this.onCloseConsultationButtonClick}
            disabled={disableCloseCase}
          >
            {t('Close consultation')}
          </Button>
          <PdfExport srIsArchived={this.props.srIsArchived} srId={this.props.sr_id}></PdfExport>
        </ButtonGroup>

        <Dialog open={this.state.dialogRequestOpen} onClose={this.onRequestDialogClose} maxWidth="sm" fullWidth>
          <div>
            <DialogTitle>{t('Request')}</DialogTitle>
            <DialogContent dividers>
              <DialogContentText>{t('Send request with following data:')}</DialogContentText>
              <TextareaAutosize
                autoFocus
                minRows={10}
                style={{
                  width: 400,
                  maxWidth: 550,
                  maxHeight: 600,
                  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                  fontSize: 'inherit',
                  resize: 'none',
                }}
                id="message"
                placeholder={t('Your message')}
                type="text"
                onChange={this.onTextfieldChange}
                value={this.state.message}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onRequestDialogClose} color="primary">
                {t('Cancel')}
              </Button>
              <Button onClick={this.onSaveRequestAsDraft} color="primary">
                {t('Save as draft')}
              </Button>
              <Button onClick={this.onSendRequest} color="primary">
                {t('Send')}
              </Button>
            </DialogActions>
          </div>
        </Dialog>

        <Dialog open={this.state.dialogAttachmentOpen} onClose={this.onAttachmentDialogClose} className="form">
          <div>
            <DialogTitle>{t('Attachments')}</DialogTitle>
            <DialogContent>
              <FormControl>
                <Select id="fileCategory" value={this.state.fileCategory} onChange={this.onFileCategoryChange}>
                  {this.fileType.map(value => (
                    <MenuItem key={value} value={value}>
                      {t(value)}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{t('File category')}</FormHelperText>
              </FormControl>
              <DialogContentText>{t('Upload your file:')}</DialogContentText>
              <span className="files text">{t('or drag it here.')}</span>
              <div className="files input">
                <input
                  type="file"
                  accept="image/jpeg, image/png, application/pdf"
                  multiple
                  onChange={this.onFileChangeHandler}
                  data-testid="file-input"
                />
              </div>
              <img src="/upload.png" className="files image" />
              <div className="files error">{this.state.fileError}</div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onAttachmentDialogClose} color="primary">
                {t('Cancel')}
              </Button>
              <Button
                onClick={this.onSaveAttachment}
                color="primary"
                data-testid="save-button"
                disabled={!this.state.fileUploadAllowed}
              >
                {t('Save')}
              </Button>
            </DialogActions>
          </div>
        </Dialog>

        <DicomUploadDialog
          open={this.state.dialogDicomOpen}
          onClose={this.onDicomDialogClose}
          saveDicom={this.saveDicom}
          className="form"
        />

        <Dialog
          open={this.state.confirmationOpen}
          onClose={this.onConfirmationDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{this.state.confirmationTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{this.state.confirmationText}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onConfirmationDisagree} color="primary">
              {this.state.confirmationDisagree}
            </Button>
            <Button onClick={this.onConfirmationAgree} color="primary" autoFocus>
              {this.state.confirmationAgree}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withTranslation()(CaseFooter);
